export default "__VITE_ASSET__b428adec__"